import React from 'react';
import EmployeeAnnouncement from '../../components/EmployeeAnnouncementComponent';
import EmployeeAppreciation from '../../components/EmployeeAppreciationComponent';
import FAQdata from '../../components/EmployeeFAQComponent';
import EmployeeGoalData from '../../components/EmployeeGoalComponent';
import PolicyData from '../../components/EmployeePoliciesComponent';
import EmpSpotlightData from '../../components/EmployeeSpotlightComponent';
import EmployeeTeam from '../../components/EmployeeTeamComponent';
import EmpToDoData from '../../components/EmployeeToDoComponent';
import '../../components/css/Dashboard-styles.css';
import EmployeeLeaveData from '../../components/EmployeeLeaveCountComponent';

const TeamMemberDashboard = () => {
    return (
        <div className="container-fluid body-bg">
            <div className="row dashmargin">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <div className="rounded-5 dashboard-container-background dashboard-annoucement-color-gradient dashboard-team-card-size">
                                        <EmployeeAnnouncement />
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <EmployeeLeaveData />
                                    {/* <div className="rounded-5 dashboard-container-background dashboard-team-card-size p-3">
                                        <div className="d-flex justify-content-between">
                                            <h1 className="tt-bold font-15 ">My Available Leaves</h1>
                                            <a href="#" className="semibold-text align-item-center font-12 text-decoration-none">Apply Leave<span><img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" /></span></a>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8 d-flex justify-content-around p-4">
                                                <div class="position-relative">
                                                    <span className="badge dashboard-casual-availability font-28 green d-flex align-items-center tt-bold position-relative"> 07</span><h2 className="font-12 bold-text mt-3 text-center">Casual</h2>
                                                    <img src="/Images/casual.png" className="position-absolute dashboard-leave-emoji-size dashboard-emoji-position" />
                                                </div>
                                                <div className="dashboard-border-line position-relative">
                                                    <span className="badge dashboard-sick-availability font-28 orange d-flex align-items-center tt-bold">04</span><h2 className="font-12 bold-text mt-3 text-center">Sick</h2>
                                                    <img src="/Images/sick.png" className="position-absolute dashboard-leave-emoji-size dashboard-emoji-position" />
                                                </div>
                                            </div>
                                            <div className="col-md-4 align-self-center">
                                                <span className="badge dashboard-pending-availability font-28 blue d-flex align-items-center tt-bold"><img src="/Images/pending.png" className="dashboard-pending-size me-1" />07</span><h2 class="font-12 bold-text mt-3">Pending Request</h2>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="col-md-5 mt-3">
                                    <EmployeeAppreciation />
                                </div>
                                <div className="col-md-4 mt-3">
                                    <div className="rounded-5 dashboard-container-background dashboard-spotlight-color-gradient dashboard-spotlight-card-size">
                                        <EmpSpotlightData />
                                        {/* <SpotlightData /> */}
                                    </div>
                                </div>
                                <div className="col-md-3 mt-3">
                                    <PolicyData />
                                </div>
                                <div className="col-md-12">
                                    <FAQdata />
                                </div>
                                <div className="col-md-12">
                                    <EmployeeTeam />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="rounded-5 dashboard-container-background dashboard-team-dashboard-rightside-height">
                                {EmpToDoData()}
                                <div className="rounded-5">
                                    <EmployeeGoalData />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamMemberDashboard;
